import React from "react";

import { Icon } from "Components/atoms/Icon";
import { Typography } from "Components/atoms/Typography";

import {
  AirportInfo,
  FlightDetailsIcon,
  FlightDetailsInfo,
  SubHeaderContainer,
} from "./styles";
import { FlightDetailsSubHeaderProps } from "./types";
import { generateGUID } from "shared/utils/guid";

/**
 * Componente FlightDetailsSubHeader
 *
 * Exibe informações sobre um segmento de voo, incluindo aeroportos de partida e chegada, data, duração e paradas.
 *
 * @param {string} title - Título do segmento de voo (ida ou volta).
 * @param {string} departureAirport - Aeroporto de partida.
 * @param {string} arrivalAirport - Aeroporto de chegada.
 * @param {string} date - Data do voo.
 * @param {string} dayOfWeek - Dia da semana do voo.
 * @param {string} duration - Duração do voo.
 * @param {number} stops - Quantidade de paradas.
 */
export const FlightDetailsSubHeader: React.FC<FlightDetailsSubHeaderProps> = ({
  title,
  departureAirport,
  arrivalAirport,
  date,
  dayOfWeek,
  duration,
  stops,
}) => (
  <SubHeaderContainer>
    {title === "Ida" ? (
      <FlightDetailsIcon>
        <Icon library="lu" name="LuArrowUpRight" size="medium" color="black" />
      </FlightDetailsIcon>
    ) : (
      <FlightDetailsIcon>
        <Icon library="lu" name="LuArrowDownLeft" size="medium" color="black" />
      </FlightDetailsIcon>
    )}
    <FlightDetailsInfo>
      <AirportInfo>
        <Typography
          variant="caption"
          color="black"
          weight="bold"
          key={generateGUID()}
        >
          {title}:
        </Typography>
        <Typography
          variant="label"
          color="black"
          weight="bold"
          uppercase
          key={generateGUID()}
        >
          {departureAirport} - {arrivalAirport}
        </Typography>
      </AirportInfo>

      <Typography
        variant="label"
        color="black"
        weight="light"
        key={generateGUID()}
      >
        <>
          {date}, {dayOfWeek}
        </>
      </Typography>
    </FlightDetailsInfo>

    <FlightDetailsInfo>
      <Typography
        variant="label"
        color="black"
        weight="bold"
        key={generateGUID()}
      >
        <>Duração total da {title}:</>
      </Typography>
      <Typography
        variant="label"
        color="black"
        weight="light"
        key={generateGUID()}
      >
        <>
          {duration}
          {stops === 0 ? ` (1 voo direto)` : ` (${stops} voos)`}
        </>
      </Typography>
    </FlightDetailsInfo>
  </SubHeaderContainer>
);
